export default class KImage {
  public readonly source: string
  public readonly isIcon: boolean
  public readonly alt: string

  constructor (source: string, contentType: string, alt?: string) {
    this.source = source
    this.isIcon = contentType === 'image/svg+xml'
    this.alt = alt || ''
  }
}
